import { ReadsCompareProgressive, SpreadObjectBenchmark, ReadsCompareSequence } from 'wsscode_blog/com.wsscode.blog.alternative_to_clj_js';
import * as React from 'react';
export default {
  ReadsCompareProgressive,
  SpreadObjectBenchmark,
  ReadsCompareSequence,
  React
};